import { render, staticRenderFns } from "./gzhPreprintList.vue?vue&type=template&id=321fa636&scoped=true&"
import script from "./gzhPreprintList.vue?vue&type=script&lang=js&"
export * from "./gzhPreprintList.vue?vue&type=script&lang=js&"
import style0 from "./gzhPreprintList.vue?vue&type=style&index=0&id=321fa636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321fa636",
  null
  
)

export default component.exports